import classNames from 'classnames'

import Image from '@/components/base/Image'
import ImageParallax from '@/components/base/ImageParallax'
import Link from '@/components/base/Link'
import Typography from '@/components/base/Typography'

import { WPImage, WPLink } from '@/types'

export type CardProps = Partial<{
  uuid: number
  image: WPImage
  title: string
  overline: string
  paragraph: string
  link: WPLink
}>

const Card = ({ image, title, overline, paragraph, link }: CardProps) => {
  return (
    <div
      className={classNames(
        'relative h-full',
        'before:absolute before:left-0 before:top-0 before:z-0 before:h-full before:w-full before:rounded-xxs before:shadow-3xl'
      )}
      data-motion-card
    >
      <div className="relative z-10 h-full rounded-xxs bg-white px-xs pb-sm pt-xs">
        <div className="grid gap-y-sm">
          {image ? (
            <ImageParallax className="rounded-xxs">
              {(ref) => (
                <div className="aspect-h-[285] aspect-w-[361]">
                  <Image
                    fill
                    ref={ref}
                    size="full"
                    loading="lazy"
                    source={image}
                    alt={image?.alt}
                    className="rounded-xxs"
                  />
                </div>
              )}
            </ImageParallax>
          ) : null}

          {overline ? (
            <Typography variant="small" paragraph className="text-neutral-20">
              {overline}
            </Typography>
          ) : null}

          {title ? (
            <Typography
              variant="h6"
              component="h6"
              className="text-dark [&_em]:text-blue-soft"
            >
              {title}
            </Typography>
          ) : null}

          {paragraph ? (
            <Typography variant="body" paragraph className="text-neutral-20">
              {paragraph}
            </Typography>
          ) : null}

          {link ? (
            <div className="flex">
              <Link
                href={link?.url || '/'}
                target={link?.target}
                className="text-dark"
                textClassName="text-dark"
              >
                {link?.title}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default Card
